import { useContext } from 'react';
import { ContextBuilder } from '../context/builder/reducers';

export default function useChange(index) {
    const { state, dispatch } = useContext(ContextBuilder);

    return function (ind, name, text) {
        const data = {...state.data};
        let dataItem = data.value[index];
        if (name === null || name === undefined) {
            throw new Error('Empty name');
        }
        const names = name.split('.');
        let dataVal = dataItem.content;
        names.forEach((nameItem, i, arr) => {
            if (dataVal.hasOwnProperty(nameItem)) {
                if (i === arr.length - 1) {
                    dataVal[nameItem] = text;
                } else {
                    dataVal = dataVal[nameItem];
                }
            } else {
                if (i === arr.length - 1) {
                    dataVal[nameItem] = null;
                } else {
                    dataVal = dataVal[nameItem];
                }
            }
        });
        dataVal = text;

        dispatch({ type: 'data', payload: { data: data } });
    }
}
